export interface LiveRankRow {
  id: number;
  title: string;
  category: string;
  heat: number;
  state: "爆" | "热" | "新";
  detail: string;
}

export const liveRankRows: LiveRankRow[] = [
  { id: 1, title: "《瓜田不设防》收官夜爆灯求婚 名场面连上三个热搜", category: "娱乐", heat: 96, state: "爆", detail: "全网讨论中 · 82.4w 帖" },
  { id: 2, title: "周末晴乐队巡演首站门票秒空 黄牛叫价翻十倍", category: "娱乐", heat: 91, state: "爆", detail: "热度持续走高" },
  { id: 3, title: "年度「全民二创」歌曲大奖 翻唱挑战播放破十亿", category: "社会", heat: 88, state: "爆", detail: "多平台在榜" },
  { id: 4, title: "某顶流主播连麦金句爆红 表情包全网疯传", category: "娱乐", heat: 84, state: "热", detail: "24h 新增 9.8w 帖" },
  { id: 5, title: "冷门小城靠一支短片出圈 文旅局连夜上分", category: "文旅", heat: 79, state: "热", detail: "周末打卡量激增" },
  { id: 6, title: "神秘旗舰机发布会一句话刷屏 参数被逐帧解读", category: "科技", heat: 74, state: "热", detail: "评测圈全面跟进" },
  { id: 7, title: "小区「万步健走」挑战爆火 阿姨们组团冲榜", category: "社会", heat: 70, state: "热", detail: "话题讨论破千万" },
  { id: 8, title: "职业联赛决赛点球大战 神扑瞬间刷爆弹幕", category: "体育", heat: 66, state: "热", detail: "热度稳定上升" },
  { id: 9, title: "古风舞台视觉被逐帧考古 幕后班底集体出圈", category: "娱乐", heat: 61, state: "新", detail: "讨论区新增 1.2w" },
  { id: 10, title: "方言神曲横扫街巷 全城大爷大妈都在哼", category: "社会", heat: 57, state: "新", detail: "新晋上榜" },
];

export const liveTabs = ["全部", "娱乐", "社会", "科技", "文旅", "体育"] as const;

export interface StoryCard {
  id: number;
  tag: string;
  title: string;
  summary: string;
  heat: number;
  image: string;
}

export const storyCards: StoryCard[] = [
  {
    id: 1,
    tag: "娱乐 · 综艺",
    title: "《瓜田不设防》收官夜：那盏爆灯，点亮了整季名场面",
    summary: "从互怼开场到握手收尾，一档把「吵架」做成情怀的综艺，凭什么让全网哭着笑？镜头背后还有哪些被剪掉的名场面。",
    heat: 96,
    image: "https://readdy.ai/api/search-image?query=editorial%20flat%20illustration%20of%20a%20grand%20award%20style%20TV%20studio%20stage%20bathed%20in%20warm%20golden%20spotlights%20with%20gold%20confetti%20falling%20and%20an%20empty%20vintage%20mic%20stand%20at%20center%2C%20deep%20coral%20red%20and%20warm%20amber%20palette%2C%20stylized%20minimal%20clean%20warm%20background%2C%20high%20detail%2C%20no%20people&width=960&height=640&seq=card-01-x1&orientation=landscape",
  },
  {
    id: 2,
    tag: "娱乐 · 演出",
    title: "周末晴乐队首站官宣即秒空，黄牛价为何还在疯涨？",
    summary: "一张票从发售到售罄只用四分钟。有人为情怀，有人拼手速，这场「票务大战」背后，是乐队、主办与歌迷的三方拉扯。",
    heat: 91,
    image: "https://readdy.ai/api/search-image?query=minimal%20editorial%20illustration%20of%20an%20open%20air%20concert%20arena%20at%20dusk%20with%20silhouette%20crowd%20and%20glowing%20stage%20lights%2C%20tickets%20flying%20upward%20into%20the%20air%2C%20warm%20amber%20and%20coral%20tones%2C%20stylized%20flat%20art%2C%20clean%20composition%2C%20high%20detail%2C%20no%20readable%20text&width=960&height=640&seq=card-02-x1&orientation=landscape",
  },
  {
    id: 3,
    tag: "社会 · 全民二创",
    title: "一首歌被唱进千家万户，全民翻唱大奖赛凭什么破十亿",
    summary: "大爷的唢呐、外卖小哥的快递车、幼儿园的午睡铃……同一段旋律在不同生活里开了花，这大概是最松弛的一次出圈。",
    heat: 88,
    image: "https://readdy.ai/api/search-image?query=warm%20editorial%20illustration%20of%20a%20sunny%20residential%20neighborhood%20balcony%20with%20an%20old%20radio%2C%20flowers%20and%20hanging%20laundry%2C%20melody%20notes%20drifting%20up%20into%20a%20soft%20golden%20sky%2C%20warm%20amber%20and%20coral%20palette%2C%20stylized%20minimal%20storybook%20art%2C%20high%20detail%2C%20no%20people&width=960&height=640&seq=card-03-x1&orientation=landscape",
  },
  {
    id: 4,
    tag: "娱乐 · 直播",
    title: "一场连麦翻车，意外炸出今年最好笑的表情包素材",
    summary: "本来只是例行聊天，谁料一句口误成为全场高光。事后主播自嘲营业，粉丝却在弹幕里把梗玩出了新高度。",
    heat: 84,
    image: "https://readdy.ai/api/search-image?query=playful%20flat%20illustration%20of%20a%20large%20floating%20smartphone%20screen%20with%20cartoon%20laughing%20emoji%20faces%20and%20colorful%20chat%20message%20bubbles%20bursting%20outward%2C%20live%20broadcast%20concept%2C%20warm%20coral%20background%2C%20stylized%20minimal%2C%20high%20detail%2C%20no%20readable%20text&width=960&height=640&seq=card-04-x1&orientation=landscape",
  },
  {
    id: 5,
    tag: "文旅 · 城市出圈",
    title: "三分钟短片带火一座冷门小城，这波接得住吗？",
    summary: "当流量突然砸向一座安静小城，民宿老板连夜改价，文旅局加班上新。出圈之后的「留量」，才是真正的考题。",
    heat: 79,
    image: "https://readdy.ai/api/search-image?query=warm%20editorial%20illustration%20of%20a%20charming%20small%20ancient%20town%20street%20lined%20with%20warm%20paper%20lanterns%2C%20stone%20bridges%20and%20stalls%2C%20golden%20hour%20lighting%2C%20coral%20and%20amber%20palette%2C%20stylized%20minimal%20travel%20art%2C%20clean%2C%20high%20detail%2C%20no%20text&width=960&height=640&seq=card-05-x1&orientation=landscape",
  },
  {
    id: 6,
    tag: "科技 · 发布会",
    title: "新旗舰一句「还是全面屏最实在」，发布会直接封神",
    summary: "没有参数轰炸，没有夸张宣传。一句返璞归真的文案，反而让网友逐帧分析起每一页 PPT，讨论度逆势走高。",
    heat: 74,
    image: "https://readdy.ai/api/search-image?query=sleek%20stylized%20illustration%20of%20a%20futuristic%20smartphone%20floating%20with%20subtle%20glowing%20holographic%20spec%20ring%20and%20gentle%20speed%20lines%2C%20warm%20coral%20and%20gold%20gradient%20studio%20background%2C%20minimal%20tech%20editorial%20art%2C%20high%20detail%2C%20no%20readable%20text&width=960&height=640&seq=card-06-x1&orientation=landscape",
  },
];

export const arenaTabs = [
  { key: "综艺", count: 32, desc: "舞台前后、剧本之外的名场面", icon: "ri-vidicon-line" },
  { key: "饭圈", count: 41, desc: "打榜、应援与爱豆的日常", icon: "ri-heart-3-line" },
  { key: "明星八卦", count: 27, desc: "热搜背后的来龙去脉", icon: "ri-star-smile-line" },
  { key: "社会热点", count: 36, desc: "身边大小事，全民都在聊", icon: "ri-earth-line" },
  { key: "科技圈", count: 19, desc: "发布会、产品与行业大瓜", icon: "ri-cpu-line" },
  { key: "体育圈", count: 22, desc: "赛场内外，谁主沉浮", icon: "ri-trophy-line" },
];

export interface ChampionItem {
  id: number;
  name: string;
  vote: number;
  isChampion?: boolean;
}

export const championContenders: ChampionItem[] = [
  { id: 1, name: "爆灯求婚名场面", vote: 482, isChampion: true },
  { id: 2, name: "全民二创歌曲", vote: 396 },
  { id: 3, name: "冷门小城出圈", vote: 342 },
  { id: 4, name: "直播金句表情包", vote: 288 },
];

export const championTracks = [
  { label: "热度值", value: "9.6k" },
  { label: "讨论声量", value: "82w" },
  { label: "全民票选", value: "482w" },
];

export const weekTrend = [
  { day: "周一", topic: "综艺名场面开始发酵", heat: 62 },
  { day: "周二", topic: "翻唱挑战加入战局", heat: 71 },
  { day: "周三", topic: "投票人数单日破百万", heat: 78 },
  { day: "周四", topic: "话题热度登顶", heat: 92 },
  { day: "周五", topic: "进入冲刺阶段", heat: 88 },
  { day: "周六", topic: "多城线下应援", heat: 94 },
  { day: "周日", topic: "本周瓜王诞生", heat: 100 },
];

export const howSteps = [
  { no: "01", icon: "ri-radar-line", title: "全网抓取热点", desc: "从微博、短视频、新闻聚合等多源实时捕捉正在发酵的话题，去重并识别情绪拐点。" },
  { no: "02", icon: "ri-line-chart-line", title: "多维度打热力值", desc: "综合讨论量、增速、跨平台声量与转发结构，为每个话题生成 0–100 的热力指数。" },
  { no: "03", icon: "ri-team-line", title: "全民票选决出瓜王", desc: "榜单之外，每周开放全民投票。票选最高者成为当周吃瓜王第一名，登榜受封。" },
];

export const navLinks = [
  { label: "实时热榜", href: "#rank" },
  { label: "今日瓜榜", href: "#today" },
  { label: "分区速览", href: "#arena" },
  { label: "本周争霸", href: "#arena-top" },
  { label: "榜单玩法", href: "#how" },
];